import Enlang from './entries/en-US';
import Frlang from './entries/fr_FR';

const AppLocale = {
  en: Enlang,
  fr: Frlang
};

export default AppLocale;
